import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";

// Import your custom CSS file
import "../../styles/employeeDetails.css"; 

const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      text: "My son’s marks improved from 60% to 85% within a year.",
      name: "Mrs. Latha",
      role: "Parent",
      rating: 5,
    },
    {
      id: 2,
      text: "Best tuition for CBSE students in Chennai. Teachers are very patient.",
      name: "Mr. Ramesh",
      role: "Parent",
      rating: 5,
    },
   
  ];

  // Helper to render stars
  const renderStars = (count) => {
    return Array(count)
      .fill(0)
      .map((_, i) => <span key={i} className="star">★</span>);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <Swiper
          spaceBetween={40} // Space between cards
          slidesPerView={1} // Default Mobile: 1 card
          loop={true}
          centeredSlides={false} // standard left alignment usually works best for 2 items
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // Tablet & Desktop: Show 2 cards like the image
            768: {
              slidesPerView: 2,
            }
          }}
          modules={[Autoplay, Pagination]}
          className="testimonials-swiper"
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="testimonial-card-wrapper">
                
                {/* 1. The Quote Box */}
                <div className="quote-box">
                  <p className="quote-text">
                    {item.text}
                  </p>
                  
                  {/* Floating Profile Circle (Overlapping the bottom border) */}
                   <div className="profile-wrapper">
                    <div className="profile-circle">
                      <i className="bi bi-person-fill profile-icon"></i>
                    </div>
                  </div>
                </div>

                {/* 2. Info Section (Stars, Name, Role) */}
                <div className="student-info">
                  <div className="rating-stars">
                    {renderStars(item.rating)}
                  </div>
                  <h4 className="student-name">{item.name}</h4>
                  <span className="student-role">{item.role}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>  
  );
};

export default Testimonials;